import { create } from 'zustand';

export const useHelpStore = create((set) => ({
  isHelpMode: false,
  hoveredId: null,
  hoverRect: null, // { top, left, width, height } of the hovered element

  toggleHelp: () => set(s => ({ isHelpMode: !s.isHelpMode, hoveredId: null, hoverRect: null })),
  setHovered: (id, rect) => set({ hoveredId: id, hoverRect: rect }),
  clearHovered: () => set({ hoveredId: null, hoverRect: null }),
}));
